import { TrafficCone } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TrafficConeIcon = createLucideIcon(TrafficCone);
